import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Search from "./pages/Search";
import Main from "./pages/Main";
import DetailDiploma from "./pages/DetailDiploma";
import NotFound from "./pages/NotFound";
import RequestDiploma from "./pages/RequestDiploma";

import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Search />
        </Route>

        <Route exact path="/main">
          <Main />
        </Route>

        <Route exact path="/detail">
          <DetailDiploma />
        </Route>

        <Route exact path="/yeu-cau-cap-ban-sao">
          <RequestDiploma />
        </Route>

        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
